/**
 * Prefix used for MHID generation and validation.
 */
export var MHID_PREFIX = 'CAD';
//# sourceMappingURL=MhidPrefix.js.map